import { LmsUserStatus } from "~/LMS/LmsUserStatus";
import { openModal } from "~/AddToCart/ModalSevice";
import { LmsInactiveModal } from "~/LMS/components/LmsInactiveModal/LmsInactiveModal";
import { LmsNotApprovedModal } from "~/LMS/components/LmsNotApprovedModal/LmsNotApprovedModal";
import { MY_ACCOUNT_PAGE } from "~/utils/url/staticUrls";
import { getUserStatus } from "~/LMS/lmsUtils";

const BE_LMS_REDIRECT = "/training-campus";
function isUrlLms(url: string) {
  url = url.toLowerCase();
  return url.includes(BE_LMS_REDIRECT);
}

function lmsLinkClickListener(e: MouseEvent) {
  const url = (e.target as HTMLElement).closest("a")?.href;
  if (url && isUrlLms(url)) {
    const userStatus = getUserStatus();
    let modal;

    const navigateToUrl = () => window.location.assign(url);
    const navigateToSettings = () => window.location.assign(MY_ACCOUNT_PAGE);

    if (userStatus === LmsUserStatus.Inactive) {
      modal = (close: () => void) => (
        <LmsInactiveModal onClose={close} onIgnore={navigateToUrl} onSetup={navigateToSettings} />
      );
    } else if (userStatus === LmsUserStatus.Not_approved) {
      modal = (close: () => void) => <LmsNotApprovedModal onClose={close} onConfirm={navigateToUrl} />;
    }
    if (modal) {
      e.preventDefault();
      openModal("lms-notification", modal);
    }
  }
}

export function bindLmsLinkListener() {
  window.addEventListener("click", lmsLinkClickListener, { capture: true });
}
